import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=35743024&scoped=true"
var script = {}
import style0 from "./mine.vue?vue&type=style&index=0&id=35743024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35743024",
  null
  
)

export default component.exports